import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  ambassador: [],
  selectedAmbassador: {},
};

const AmbassadorSlice = createSlice({
  name: "ambassadorUser",
  initialState,
  reducers: {
    requestPending: (state) => {
      state.isLoading = true;
    },
    ambassadorSuccess: (state, { payload = [] }) => {
      state.isLoading = false;
      state.ambassador = payload || [];
    },
    getSelectedAmbassador: (state, { payload }) => {
      state.isLoading = false;
      state.selectedAmbassador = payload;
    },
    requestFail: (state, { payload }) => {
      state.isLoading = false;
    },
  },
});
const { reducer, actions } = AmbassadorSlice;
export const {
  requestPending,
  ambassadorSuccess,
  getSelectedAmbassador,
  requestFail,
} = actions;
export default reducer;
